<template>
<div>
	<div class="am-blog-inside"
		:class="{ 'is-idle': !init || !loaded }"
	>
		<div style="z-index: 1;" class="am-blog-inside__background" :data-src="background">
		</div>

		<div style="height: 100vh" class="am-blog-inside__container">
			<div class="am-blog-inside__wrapper">
				<header class="am-blog-inside__header">
					<am-text class="am-blog-inside__title am-blog-inside__title--first" type="title">
						<span>
							{{ titles[0] }}
						</span>
					</am-text>
					<am-text class="am-blog-inside__title am-blog-inside__title--second" type="title">
						<span>
							{{ titles[1] }}
						</span>
					</am-text>
					<am-text class="am-blog-inside__title am-blog-inside__title--third" type="title">
						<span>
							{{ titles[2] }}
						</span>
					</am-text>
				</header>

				<am-text class="am-blog-inside__text" type="body">
					{{ text }}
				</am-text>

			</div>
			<div class="inside-post-holder">
				<router-link class="am-blog-inside__img-btn" :to="{path: '/post/' + posts[0].slug}">
					<div class="am-blog-inside__image inside-post" :data-src="posts[0].img"> 
						<p class="am-blog-inside__img-btn-text"> <span class="text-uppercase">{{ posts[0].category.name }}</span><br> {{ posts[0].title }}</p> 
					</div>
				</router-link>
				<router-link class="am-blog-inside__img-btn" :to="{path: '/post/' + posts[1].slug}">
					<div class="am-blog-inside__first inside-post" :data-src="posts[1].img"> 
						<p class="am-blog-inside__img-btn-text"> <span class="text-uppercase">{{ posts[0].category.name }}</span><br> {{ posts[1].title }}</p> 
					</div>
				</router-link>
			</div>

		</div>


	</div>
	<div class="am-blog-inside__list">
		<div v-for="(post, index) in allPostsAfter" v-bind:key="post.id" v-bind:index="index" class=" pc-screens ">
			<div class="row m-0" >
				<template v-if="index %2 != 0">
					<div class="col-md-6 p-0">

						<div class=" am-blog-inside__listimg" :data-src=" post.img"></div>
					</div>
					<div class="col-md-6 p-0">
						<div class="am-blog-inside__listtitle">
							<p class="text-uppercase am-blog-inside__listtitle__header">dicas</p>
							<p class="am-blog-inside__listtitle__text">{{post.title}}</p>
							<router-link class="open--modal text-white text-decoration-none" :to="{path: '/post/' + post.slug}">Saiba mais</router-link> 
						</div>
					</div>
				</template>
				<template v-if="index %2 == 0">
					<div class="col-md-6 p-0">
						<div class="am-blog-inside__listtitle">
							<p class="text-uppercase am-blog-inside__listtitle__header">dicas</p>
							<p class="am-blog-inside__listtitle__text">{{post.title}}</p>
							<router-link class="open--modal text-white text-decoration-none" :to="{path: '/post/' + post.slug}">Saiba mais</router-link>
						</div>
					</div>
					<div class="col-md-6 p-0">

						<div class=" am-blog-inside__listimg" :data-src="post.img"></div>
					</div>
				</template>
			</div>
		</div>


		<div v-for="(post, index) in allPostsAfter" v-bind:key="post.id" v-bind:index="index" class="phone-screens m-0">
			<router-link class="am-blog-inside__img-btn" :to="{path: '/post/' + post.slug}">
				<div style="height: 30vh" class="am-blog-inside__first" :data-src="post.img"> 
					<p class="am-blog-inside__img-btn-text"> <span class="text-uppercase">{{ post.category.name }}</span><br> {{ post.title }}</p> 
				</div>
			</router-link>
		</div>


	</div>
</div>

</template>
A
<script>
import AMText from '@/components/atoms/AMText'
import { TweenMax, Power2 } from 'gsap/TweenMax'

export default {
	components: {
		'am-text': AMText,
	},

	props: {
		init: {
			type: Boolean,
			default: false 
		},
		titles: {
			type: Array,
			default: () => ([
				'Lorem.',
				'Ipsum.',
				'Rules'
			])
		},
		text: {
			type: String,
			default: 'Adipisicing quo delectus deleniti aut quis, quasi totam? Vero adipisci nostrum itaque ducimus culpa?'
		},
		posts: {
			type: Array,
			default: [ 
				{
					id: 2, 
					title: "Entenda o que é a Arquitetura Moderna e quais são suas influências 1", 
					slug: "slug",
					category: "category",
					img: require('@/assets/images/hero/image.jpg'),
					text: "text",
					created_at: "created_at"
				},
				{
					id: 3, 
					title: "Entenda o que é a Arquitetura Moderna e quais são suas influências 1", 
					slug: "slug",
					category: "category",
					img: require('@/assets/images/hero/image.jpg'),
					text: "text",
					created_at: "created_at"
				}
			]
		},
		background: {
			type: String,
			default: 'https://placeimg.com/640/480/nature/grayscale'
		},
		/* image: {
			type: String,
			default: 'https://placeimg.com/640/480/nature'
		} */
	},
	
	data: () => ({
		loaded: false
	}),
	computed: {
		allPostsAfter: function () {
			return this.posts.slice(2, this.posts.length);
		},
		postsHighlight: function () {
			return this.posts.slice(0, 2);
		},
	},
	watch: {
		init(value) {
			if (value){
				console.log("watch chamado com valor: " + value)
				this.onLoad()
			}
		}
	},

	mounted() {
		if (this.init){
			console.log("init chamado");
			this.onLoad()
		}
	},

	methods: {
		start() {
			// Background
			console.log("start chamado");
			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-blog-inside__background'), 1.5, {
				y: '-200px',
				opacity: 0,
				ease: Power2.easeOutl
			})

			// Gallery
			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-blog-inside__image, .am-blog-inside__listimg, .am-blog-inside__image_bottom, .am-blog-inside__first'), 2, {
				x: '30%',
				opacity: 0,
				ease: Power2.easeOut
			})

			// Gallery
			/* TweenMax.staggerFrom(this.$el.querySelectorAll(''), 2, {
				x: '30%',
				opacity: 0,
				ease: Power2.easeOut
			}) */

			// Titles
			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-blog-inside__title span'), 1.5, {
				delay: .2,
				y: '200px',
				ease: Power2.easeOut
			}, .2)
		},

		onLoad() {
			console.log("on load chamado");
			let images = this.$el.querySelectorAll('.am-blog-inside__background, .am-blog-inside__listimg')
			let imagesBlog = this.$el.querySelectorAll('.am-blog-inside__image, .am-blog-inside__image_bottom, .am-blog-inside__first')
			let allLoaded = false;

			images.forEach((image, index) => {
				let img = new Image()

				img.src = image.dataset.src
				img.onload = () => {
					image.style.backgroundImage = `url(${img.src})`

				}
			})
			imagesBlog.forEach((image, index) => {
				let img = new Image()

				img.src = image.dataset.src
				img.onload = () => {
					image.style.backgroundImage = `linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #000000 100%), url(${img.src})`

					if (index + 1 == imagesBlog.length) {
						this.loaded = true
						this.start()
					}
				}
			})
			
		}
	}
}
</script>

<style lang="scss">
.phone-screens{
	display: none;
}
.pc-screens{
	display: block;
}

@media only screen and (max-width: 990px) {
	.inside-post-holder{
		height: 65vh;

	}
	.inside-post{
		height: 50% !important;
	}
	.phone-screens{
		display: block;
	}
	.pc-screens{
		display: none;
	}
}

.am-blog-inside{
	background: white;
	position: relative;
	z-index: 10;
	transition: .3s $easeInOutQuad;
	
	&__img-btn-text{
		font-family: Khand;
		color: #fff;
		font-style: normal;
		font-weight: 300;
		font-size: 40px;
		line-height: 120%;
		letter-spacing: 0.01em;
		max-width: 573px;
		margin-left: 8%;
		bottom: 30px;
		position: absolute;
	}
	&__img-btn-text span{
		font-family: Khand;
		color: #99887F;
		

		font-style: normal;
		font-weight: normal;
		font-size: 15px;
		line-height: 16px;

		background: #ffffff;
		border-radius: 100px;
		padding: 5px 25px;
	}

	@include grid-media($smartphone-grid) {
		&__img-btn-text{
			font-size: 26px;
		}
	}

	&__container{
		display: flex;
		flex-flow: column;
		height: 100%;
		@include outer-container;
	}
	&__wrapper{
		flex: 1;
		@include grid-column(6);
	}
	&__background{
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 120px;
		opacity: 1;
		
		background-size: cover;
		background-position: center;
	}
	&__header{
		margin-top: 54px;
		margin-bottom: 97px;
		padding-bottom: 24px;
		position: relative;
		z-index: 2;
		&:after{
			content: "";
			position: absolute;
			width: 100%;
			height: 1px;
			bottom: -1px;
			background: rgba($c-gray, .6);
			transition: 1s $easeInOutQuad .75s;
		}
	}
	@include grid-media($smartphone-grid) {
		&__header{
			margin-bottom: 0px;
			margin-top: 64px;

		}
	}

	&__title{
		line-height: 56px;
		overflow: hidden;
		span{
			display: block;
		}
		&--first{
			color: white;
		}
		&--second{
			color: #E3E3E3;
		}
		&--third{
		}
	}
	&__text{
		opacity: .8;
		margin-bottom: 40px;
		transition: 1s $easeOutQuad 1.5s;
	}
	&__image{
		flex: 1;
		background-size: cover;
		background-position: center;
	}
	&__image_bottom{
		flex: 1;
		background-size: cover;
		background-position: center;
	}

	&.is-idle{
		opacity: 0;
		.am-blog-inside{
			&__header{
				&:after{
					width: 0%;
					opacity: 0;
					transition: .5s $easeInOutQuad;
				}
			}
			&__text{
				transform: translateY(20px);
				opacity: 0;
				transition: .5s $easeInOutQuad;
			}
		}
	}

	@include grid-media($tablet-grid) {
		&__wrapper{
			@include grid-column(4);
		}
	}

	@include grid-media($desktop-grid) {
		display: block;
		&__image{
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 50%;
			
			&:after{
				content: "";
				display: block;
				padding-top: 60%;
			}
		}
		&__first{
			position: absolute;
			/* top: 403px; */
			/* right: 50%; */
			bottom: 0;
			left: 0;
			background-size: cover;
			background-position: center;

			/* height: 480px; */
			height: 44vh;
			width: 50%;
			&:after{
				content: "";
				display: block;
				padding-top: 60%;
			}
		}
		&__list__item{
			/* columns: 2; */
		}
		&__listimg{
			position: relative;
			/* top: 403px; */
			/* right: 50%; */
			/* bottom: 0; */
			/* left: 0; */
			height: 480px;
			/* width: 50%; */
			background-position: center;
			background-size: cover;
			&:after{
				content: "";
				display: block;
				padding-top: 60%;
			}
		}
		&__listtitle{
			position: relative;
			/* top: 403px; */
			/* right: 50%; */
			/* bottom: 0; */
			/* left: 0; */
			height: 480px;
			max-width: 489px;
			margin-left: 83px ;
			margin-right: 83px ;
			padding: 96px 0px;
			&__text{
				font-family: Khand;
				font-style: normal;
				font-weight: 300;
				font-size: 50px;
				line-height: 120%;
				letter-spacing: 0.01em;
				color: #6D594F;
			}
			&__header{
				font-family: Khand;
				font-style: normal;
				font-weight: normal;
				font-size: 25px;
				line-height: 25px;
				letter-spacing: 0.01em;
				color: #6D594F;

				width: 80px;
				border-bottom: 1px solid #6D594F;
			}
		}

		&__image_bottom{
			position: absolute;
			top: 50%;
			right: 0;
			bottom: 0;
			left: 50%;
			&:after{
				content: "";
				display: block;
				padding-top: 60%;
			}
		}
		&__background{
			height: 200px;
		}
		&__header{
			margin-top: 144px;
			&:after{
				width: 280px;
			}
		}
		&__title{
			line-height: 64px;
		}
		&__wrapper{
			@include grid-column(5);
		}
	}
	@include grid-media($smartphone-grid) {

	}

}
</style>
